<template>
<div class="container-fluid bg-dark">

	<div class="row">

		<div class="col-sm-6 col-md-6 offset-md-3 offset-sm-0">

			<div class="text-center pt-3">

				<router-link :to="{path: '/'}">
					<img id="logo"
					     src="/static/img/logo.png" />
				</router-link>

			</div>

		</div>

		<div class="col-sm-6 col-md-3 py-4 text-right">
			<user-menu class="hidden-xs-down"></user-menu>
		</div>

		<flash-messages-list></flash-messages-list>

	</div>

</div>
</template>

<script>
import AuctionSelect from '@/components/elements/AuctionSelect'
import UserMenu from '@/components/elements/UserMenu'
import FlashMessagesList from '@/components/elements/FlashMessages/FlashMessagesList'

export default {
	components: {
		AuctionSelect,
		UserMenu,
		FlashMessagesList
	},
	data() {
		return {
		}
	},
	methods:{

	},
	mounted(){
		
	}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// MainHeader.vue?4d3b6adc